// extracted by mini-css-extract-plugin
module.exports = {"block":"xFRpK","background":"s9DUb","content":"bAWOw","title":"Pfy1w","list":"uxUdZ","links":"AGgKV","link":"HQLCv","linkImage":"HDK5M"};